import { Grid } from '@mui/material';
import { AuditDateTimeRangeFields } from '../../../../components/AuditDateTimeRangeFields';
import { CustomIdField } from '../../../../components/CustomIdField';

/**
 * Filter form for spot schedule status report.
 */
export function ScheduleStatusSpotForm(_p: object) {
  return (
    <div>
      <AuditDateTimeRangeFields />
      <Grid container spacing={2}>
        <Grid item xs={12} md={4} lg={3} xl={2}>
          <CustomIdField />
        </Grid>
      </Grid>
    </div>
  );
}
